._text-mask-inspector-panel_yla1v_1 .input-container {
  align-items: center;
  margin-right: 4px; }

._text-mask-inspector-panel_yla1v_1 ._text-mask-over-media_yla1v_5 {
  height: 28px;
  padding: 22px 24px;
  display: grid;
  grid-template-columns: 28px 1fr;
  grid-template-rows: 28px;
  gap: 12px; }

._text-mask-inspector-panel_yla1v_1 ._text-mask-change-media_yla1v_13 {
  width: 28px;
  height: 28px;
  padding: 0;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  padding: 0; }
  ._text-mask-inspector-panel_yla1v_1 ._text-mask-change-media_yla1v_13:hover {
    outline: 2px solid #d3edff; }

._text-mask-inspector-panel_yla1v_1 ._text-mask-preview-media_yla1v_25 {
  object-fit: cover; }

._text-mask-inspector-panel_yla1v_1 ._composites-media-thumbnail-input_yla1v_28 {
  height: 28px;
  padding: 9px 24px;
  display: grid;
  grid-template-columns: 28px 1fr;
  grid-template-rows: 28px;
  gap: 12px; }

._text-mask-inspector-panel_yla1v_1 ._text-mask-apply-overlay_yla1v_36 {
  padding: 10px 0; }

._text-mask-inspector-panel_yla1v_1 ._text-mask-text-section_yla1v_39 ._text-section-controls_yla1v_39 {
  margin: 12px 24px 24px;
  height: 28px;
  display: grid;
  align-items: center;
  gap: 8px; }

._text-mask-inspector-panel_yla1v_1 ._text-mask-text-section_yla1v_39 ._text-section-label_yla1v_46 {
  margin: 12px 24px; }

._text-mask-inspector-panel_yla1v_1 ._text-mask-text-section_yla1v_39 ._text-section-controls-style_yla1v_49 {
  grid-template-columns: repeat(2, 62px); }

._text-mask-inspector-panel_yla1v_1 ._text-mask-text-section_yla1v_39 ._text-section-controls-align_yla1v_52 {
  grid-template-columns: 96px 28px; }

._text-mask-inspector-panel_yla1v_1 ._text-mask-text-section_yla1v_39 ._text-section-controls-capitalization_yla1v_55 {
  grid-template-columns: 1fr; }

._text-mask-inspector-panel_yla1v_1 ._text-mask-text-section_yla1v_39 ._text-section-controls-line-height_yla1v_58 {
  grid-template-columns: 28px 62px 32px 62px;
  gap: 6px; }

._text-mask-inspector-panel_yla1v_1 ._text-mask-text-section_yla1v_39 ._text-section-controls-headings_yla1v_62 {
  grid-template-columns: 1fr 4.5em;
  gap: 6px; }

._text-mask-inspector-panel_yla1v_1 ._text-mask-text-section_yla1v_39 ._text-mask-font-size-control_yla1v_66 {
  margin-right: 10px;
  display: flex;
  flex-wrap: wrap; }
  ._text-mask-inspector-panel_yla1v_1 ._text-mask-text-section_yla1v_39 ._text-mask-font-size-control_yla1v_66 > span {
    flex: 50%;
    margin-top: 4px; }

._text-mask-settings-panel_yla1v_74 {
  display: grid; }
  ._text-mask-settings-panel_yla1v_74 ._action-btn_yla1v_76 {
    margin: 24px auto; }
  ._text-mask-settings-panel_yla1v_74 ._input-area_yla1v_78 {
    border-bottom: 1px solid #dfe5eb; }
  ._text-mask-settings-panel_yla1v_74 textarea._translation-align-right_yla1v_80 {
    text-align: right; }
  ._text-mask-settings-panel_yla1v_74 ._text-mask-settings-direction-composite_yla1v_82 {
    position: relative;
    padding: 12px 24px; }
  ._text-mask-settings-panel_yla1v_74 ._text-mask-settings-direction_yla1v_82 {
    width: 28px;
    height: 28px;
    overflow: hidden;
    border-radius: 4px;
    position: absolute;
    top: 8px;
    right: 24px; }
  ._text-mask-settings-panel_yla1v_74 ._text-direction-btn_yla1v_93 {
    cursor: pointer; }

._measure-svg_yla1v_96 {
  position: fixed;
  visibility: hidden;
  pointer-events: none; }
  ._measure-svg_yla1v_96 text {
    fill: #000;
    dominant-baseline: text-before-edge;
    font-synthesis: none; }
